<template>
  <v-app-bar :color="$app.opts.headerColor" clipped-right flat fixed app>
    <v-btn icon small dark @click.stop="toggleLeftDrawerOpened()" class="ml-1">
      <v-icon small v-text="$vuetify.icons.values.menu"></v-icon>
    </v-btn>
    <AppLauncher app />
    <v-spacer></v-spacer>
    <NotificationHeaderItem />
    <div v-for="(item, index) in sortedHeaderItems" :key="index">
      <component :is="item.component"></component>
    </div>
    <!-- <v-btn icon small dark @click.stop="toggleRightDrawerOpened()">
      <v-icon small v-text=$vuetify.icons.values.menu></v-icon>
    </v-btn> -->
  </v-app-bar>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { NAMESPACE } from '../store'
import AppLauncher from './AppLauncher'
import NotificationHeaderItem from './NotificationHeaderItem'

export default {
  components: {
    AppLauncher,
    NotificationHeaderItem
  },
  data() {
    return {}
  },
  beforeMount() {
    const title = this.$app.opts.title
    if (title) {
      this.setTitle(title)
    }
  },
  computed: {
    ...mapState(NAMESPACE, ['title', 'isLeftDrawerOpened', 'isRightDrawerOpened']),
    ...mapGetters(NAMESPACE, ['sortedHeaderItems'])
  },
  methods: {
    ...mapActions(NAMESPACE, ['toggleLeftDrawerOpened', 'toggleRightDrawerOpened', 'setTitle'])
  }
}
</script>
